/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_Has_DueInputs */

const en_filter_has_due = /** @type {(inputs: Filter_Has_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a due date`)
};

const de_filter_has_due = /** @type {(inputs: Filter_Has_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fälligkeit`)
};

/**
* | output |
* | --- |
* | "a due date" |
*
* @param {Filter_Has_DueInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_has_due = /** @type {((inputs?: Filter_Has_DueInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Has_DueInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_has_due(inputs)
	return en_filter_has_due(inputs)
});